namespace GeniuzPOS.AdvPromo {
    export namespace PermissionKeys {
        export const Report = "";
        export const General = "";

        namespace Report_Adv {
            export const View = "4ADVANCED_PROMOTION:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19:View";
        }

        namespace Report_ItemAdv {
            export const View = "4ADVANCED_PROMOTION:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E42\u0E1B\u0E23:View";
        }

        namespace createAdvPromo {
            export const Delete = "4ADVANCED_PROMOTION:\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19:Delete";
            export const Modify = "4ADVANCED_PROMOTION:\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19:Modify";
            export const View = "4ADVANCED_PROMOTION:\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19:View";
        }

        namespace ApproveAdvPromo {
            export const Modify = "4ADVANCED_PROMOTION:\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:Modify";
            export const View = "4ADVANCED_PROMOTION:\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:View";
        }

        namespace ActiveAdvPromo {
            export const Modify = "4ADVANCED_PROMOTION:Active:Modify";
            export const View = "4ADVANCED_PROMOTION:Active:View";
        }
    }
}
